import clsx from "clsx";
import { useState } from "react";
import PropTypes from "prop-types";
import styles from "./Accordion.module.scss";
import AccordionClosed from "../../assets/icons/accordion_arrow_closed.svg";
import AccordionOpen from "../../assets/icons/accordion_arrow_active.svg";

const AccordionIcons = ({ isOpen }) => {
  const closedClass = clsx(styles.accordionIcon, {
    [styles.visible]: !isOpen,
  });
  const openClass = clsx(styles.accordionIcon, {
    [styles.visible]: isOpen,
  });
  return (
    <div className={styles.iconContainer}>
      <img
        src={AccordionClosed}
        alt="Closed"
        aria-hidden={!isOpen}
        className={closedClass}
      />
      <img
        src={AccordionOpen}
        alt="Open"
        aria-hidden={isOpen}
        className={openClass}
      />
    </div>
  );
};

export const Accordion = ({ title, children, description = "", count = 0 }) => {
  const [isOpen, setIsOpen] = useState(true);
  const titleClass = clsx(styles.accordionTitle, {
    [styles.open]: !isOpen,
  });
  return (
    <div className={styles.accordion}>
      <button
        type="button"
        className={styles.accordionHeader}
        onClick={() => setIsOpen(!isOpen)}
      >
        <AccordionIcons isOpen={isOpen} />
        <div className={styles.accordionTitleContainer}>
          <h3 className={titleClass}>
            {title} {count > 0 && <span className={styles.count}>{count}</span>}
          </h3>
          {!isOpen && description && (
            <p className={styles.accordionDescription}>{description}</p>
          )}
        </div>
      </button>
      {isOpen && <div className={styles.accordionContent}>{children}</div>}
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  count: PropTypes.number,
};
